<template>
    <div class="main_background">
        <prizeDeliveryPopup :settings="prizeDeliveryPopupSettings"></prizeDeliveryPopup>
        <div class="main_wrapper">
            <div class="main_logo">
              <img src="@/assets/icons/bs_logo.svg" alt="">
            </div>
            <div class="main_title">
              <img src="@/assets/icons/bobSepticFirstScreenTitle.svg" alt="">
            </div>
            <div class="separetor"></div>
            <div class="inputs_wrapper">
                <input :class="{error: formBody.firstName == '' && submitAction}" type="text" placeholder="First name*" v-model="formBody.firstName" required>
                <input :class="{error: formBody.SecondName == '' && submitAction}" type="text" placeholder="last name*" v-model="formBody.SecondName" required>
                <input :class="{error: formBody.phone == '' && submitAction}" maxlength="10" type="number" placeholder="Phone number*" v-model="formBody.phone" required>
                <input type="text" placeholder="address" v-model="formBody.address">
                <input :class="{error: formBody.email == '' && submitAction}" type="mail" placeholder="email*" v-model="formBody.email" required>
                <input :class="{error: formBody.delivery == '' && submitAction}" type="text" placeholder="PRIZE DELIVERY METHOD*" readonly v-model="formBody.delivery" @click="priseDeliveryInputClick" required>
            </div>
            <div class="submit_button" @click="onSubmitButtonClick">
                Submit
            </div>
            <div class="footer_text">
                <img src="@/assets/icons/bobSepticFirstScreenSubtitle.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import PrizeDeliveryPopup from "@/components/widgets/PrizeDeliveryPopup";
import {mapActions, mapMutations} from "vuex";
import errorMixin from "@/mixins/errorMixin";
import rateMixin from "@/mixins/rateMixin";

export default {
    name: "bobsSepticEvent",
    components: {
        PrizeDeliveryPopup
    },
    mixins: [mixin, errorMixin, rateMixin],
    data() {
        return {
            formBody: {
                firstName: "",
                SecondName: "",
                phone: "",
                address: '',
                email: '',
                delivery: '',
                filled: null
            },
            selected: '',
            subscription: false,
            selectOptions: [
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text: 'Mail',
                    value: 'mail'
                }
            ],
            testSubmit: true,
            prizeDeliveryPopupSettings: null,
            submitAction: null
        }
    },
    async mounted() {
        const rateData = await this.sendRateAndGetInfo(this.$route.params.questionId, 3, true)
        this.currentVote = rateData
        document.body.classList.add('bs_body')
    },
    async destroyed() {
        document.body.classList.remove('bs_body')
    },
    methods: {
        ...mapActions({
            changeAdditionalData: 'rate/changeRateAdditionalData'
        }),
        ...mapMutations({
          setProgressBarTag: 'setProgressBarTag'
        }),
        // acceptNumber() {
        //     let x = this.formBody.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //     this.formBody.phone = !x[2] ? x[1] :  + x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
        // },
        priseDeliveryInputClick() {
            this.prizeDeliveryPopupSettings = {
                showCancelButton: true,
                onEmailHandler: () => {
                    this.setDeliveryEmailMethod()
                },
                onMailHandler: () => {
                    this.setDeliveryMailMethod()
                }
            }
        },
        setDeliveryEmailMethod() {
            this.formBody.delivery = 'Email'
            this.prizeDeliveryPopupSettings = null
        },
        setDeliveryMailMethod() {
            this.formBody.delivery = 'Mail'
            this.prizeDeliveryPopupSettings = null
        },
        onSubmitButtonClick() {
            if(this.checkFormFields()) {
              this.sendFormAction()
            }
            this.submitAction = true
        },
        checkFormFields() {
            this.formBody.filled = (this.formBody.firstName !== '' && this.formBody.SecondName !== '' && this.formBody.phone !== "" && this.formBody.delivery !== "" && this.formBody.email !== "")
            return this.formBody.filled
        },
        async sendFormAction() {
            let body = {
              email: this.formBody.email,
              phone: this.formBody.phone,
              address: this.formBody.address,
              last_name: this.formBody.SecondName,
              first_name: this.formBody.firstName,
              delivery_method: this.formBody.delivery
            }
            try {
              this.setProgressBarTag({
                show: true,
                tag: 'send_additional_data'
              })
              let response = await this.changeAdditionalData({vote_uid: this.currentVote.uid, body})
              if(response) {
                window.location.replace(`${location.origin}/r/bslead/2`)
              }
            } catch (e) {
              this.showErrorModal(this.translate('PleaseEnterCorrectPlacement'))
            } finally {
              this.setProgressBarTag({
                show: false,
                tag: 'send_additional_data'
              })
            }
        },
        isServiceLogRoute() {
          return false
        },
    },
}
</script>

<style>
.bs_body {
    background-color: #e79922;
}
</style>

<style scoped>
.main_background {
    background-color: #e79922;
}
.main_logo {
    padding-top: 16px;
    width: 181px;
}
.main_wrapper {
    padding-left: 18px;
    padding-right: 18px;
}
.main_title {
    padding-top: 25px;
}
.main_title {
    max-width: 377px;
}
.subtitle {
    color: #f8f8f8;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 30px;
    font-size: 15px;
}
.separetor {
    height: 4px;
    background-color: #2F2F2F;
    margin-top: 10px;
}
.inputs_wrapper {
    margin-top: 21px;
    display: flex;
    flex-direction: column;
}
.inputs_wrapper input {
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 13px;
    margin-bottom: 23px;
    border-radius: 3px;
    outline: none;
    border: 0;
    text-transform: uppercase;
    font-size: 18px;
    font-family: 'Proxima Nova Light';
}
.error {
    outline: thick solid black !important;
}
.inputs_wrapper select {
    width: 100%;
    padding: 15px 3px 15px 15px;
    margin-bottom: 10px;
    border-radius: 3px;
    font-size: 18px;
    color: #2F2F2F;
    outline: none;
    border: 0;
    text-transform: uppercase;
    font-family: 'Proxima Nova light';
}
.inputs_wrapper input::placeholder {
    font-size: 18px;
    color: #2F2F2F;
}
select:required:invalid {
    font-size: 18px;
    color: #2F2F2F;
    padding-left: 15px;
}
option[value=""][disabled] {
    display: none;
}
option {
    font-size: 18px;
    color: #2F2F2F;
    width: 98%;
}
.subscription_checkbox {
    display: flex;
    margin-bottom: 15px;
    text-transform: uppercase;
    align-items: center;
    font-size: 13px;
}
.submit_button {
    color: white;
    background-color: black;
    padding: 8px;
    border-radius: 3px;
    width: 75px;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    font-family: 'Proxima Nova';
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer_text {
    margin-top: 38px;
    padding-bottom: 50px;
}
.footer_logo {
    margin-top: 25px;
}

@media screen and (max-width: 376px) {
    .footer_text {
        padding-left: 13px;
        padding-right: 13px;
    }
}
@media screen and (max-width: 321px) {
    .footer_text img {
      padding-left: 0;
      max-width: none !important;
    }
}

</style>